import { ShapeTypes } from '@/types/shapes';
import Konva from 'konva';
const shapes = [
    {
        title: 'Square',
        value: 'square',
        classes: 'w-16 h-16 bg-gray-200',
        getNode: (id, stage) => {
            const centerX = stage.width() / 2;
            const centerY = stage.height() / 2;
            // Define the radius of the pentagon
            const sideLength = 100;
            const object = new Konva.Rect({
                id,
                x: centerX - sideLength / 2,
                y: centerY - sideLength / 2,
                width: sideLength,
                height: sideLength,
                fill: '#EAECF0',
                stroke: null,
                opacity: 1,
                draggable: true,
            });
            object.type = ShapeTypes.SQUARE;
            return object;
        },
    },
    {
        title: 'Circle',
        value: 'circle',
        classes: 'w-16 h-16 rounded-full bg-gray-200',
        getNode: (id, stage) => {
            const centerX = stage.width() / 2;
            const centerY = stage.height() / 2;
            // Define the radius of the pentagon
            const radius = 50;
            const object = new Konva.Circle({
                id,
                x: centerX,
                y: centerY,
                radius: radius,
                fill: '#EAECF0',
                stroke: null,
                draggable: true,
                opacity: 1,
                type: ShapeTypes.CIRCLE,
            });
            object.type = ShapeTypes.CIRCLE;
            return object;
        },
    },
    {
        title: 'Triangle',
        value: 'triangle',
        classes: 'hl_image-editor-triangle',
        getNode: (id, stage) => {
            const centerX = stage.width() / 2;
            const centerY = stage.height() / 2;
            // Define the radius of the pentagon
            const sideLength = 50;
            const object = new Konva.RegularPolygon({
                id,
                x: centerX,
                y: centerY,
                sides: 3,
                radius: sideLength / (Math.sqrt(3) / 2),
                fill: '#EAECF0',
                stroke: null,
                draggable: true,
                opacity: 1,
                type: ShapeTypes.TRIANGLE,
                lineJoin: 'round',
            });
            object.type = ShapeTypes.TRIANGLE;
            return object;
        },
    },
    {
        title: 'Star',
        value: 'star',
        classes: 'hl_image-editor-star',
        getNode: (id, stage) => {
            const centerX = stage.width() / 2;
            const centerY = stage.height() / 2;
            // Define the radius of the pentagon
            const outerRadius = 50;
            const innerRadius = 25;
            const object = new Konva.Star({
                id,
                x: centerX,
                y: centerY,
                numPoints: 6,
                innerRadius: innerRadius,
                outerRadius: outerRadius,
                fill: '#EAECF0',
                stroke: null,
                draggable: true,
                opacity: 1,
                type: ShapeTypes.STAR,
            });
            object.type = ShapeTypes.STAR;
            return object;
        },
    },
    {
        title: 'Pentagon',
        value: 'pentagon',
        classes: 'hl_image-editor-pentagon',
        getNode: (id, stage) => {
            const centerX = stage.width() / 2;
            const centerY = stage.height() / 2;
            // Define the radius of the pentagon
            const radius = 50;
            const object = new Konva.RegularPolygon({
                id,
                x: centerX,
                y: centerY,
                sides: 5,
                radius: radius,
                fill: '#EAECF0',
                draggable: true,
                opacity: 1,
                type: ShapeTypes.PENTAGON,
            });
            object.type = ShapeTypes.PENTAGON;
            return object;
        },
    },
    {
        title: 'Hexagon',
        value: 'hexagon',
        classes: 'hl_image-editor-hexagon',
        getNode: (id, stage) => {
            const centerX = stage.width() / 2;
            const centerY = stage.height() / 2;
            // Define the radius of the pentagon
            const sideLength = 50;
            const object = new Konva.RegularPolygon({
                id,
                x: centerX,
                y: centerY,
                sides: 6,
                radius: sideLength,
                fill: '#EAECF0',
                draggable: true,
                opacity: 1,
                type: ShapeTypes.HEXAGON,
            });
            object.type = ShapeTypes.HEXAGON;
            return object;
        },
    },
    // {
    //   title: 'Heart',
    //   value: 'heart',
    //   classes: 'hl_image-editor-heart',
    //   getNode: (stage: Konva.Stage, color: string, opacity: number) => {
    //     const centerX = stage.width() / 2
    //     const centerY = stage.height() / 2
    //     return new Konva.Path({
    //       x: centerX,
    //       y: centerY,
    //       data: 'M213.1,6.7c-32.4-14.4-73.7,0-88.1,30.6C110.6,4.9,67.5-9.5,36.9,6.7C2.8,22.9-13.4,62.4,13.5,110.9C33.3,145.1,67.5,170.3,125,217c59.3-46.7,93.5-71.9,111.5-106.1C263.4,64.2,247.2,22.9,213.1,6.7z',
    //       fill: color,
    //       draggable: true,
    //       width: 100,
    //       height: 100,
    //       opacity,
    //     })
    //   },
    // },
    // {
    //   title: 'Burst',
    //   value: 'burst',
    //   classes: 'hl_image-editor-burst-12',
    //   getNode: (stage: Konva.Stage, color: string, opacity: number) => {
    //     const centerX = stage.width() / 2
    //     const centerY = stage.height() / 2
    //     // Number of lines in the burst
    //     const numberOfLines = 12
    //     // Radius of the burst
    //     const burstRadius = 50
    //     // Tension for sharper corners
    //     const tension = 1
    //     // Create a burst of 12 lines
    //     const lines = []
    //     for (let i = 0; i < numberOfLines; i++) {
    //       // Calculate the angle for each line in the burst
    //       const angle = (i * 2 * Math.PI) / numberOfLines
    //       // Calculate the position of each line in the burst
    //       const x = centerX + burstRadius * Math.cos(angle)
    //       const y = centerY + burstRadius * Math.sin(angle)
    //       lines.push(x, y)
    //     }
    //     // Create a line connecting the points
    //     return new Konva.Line({
    //       points: lines,
    //       stroke: color,
    //       fill: color,
    //       strokeWidth: 2,
    //       closed: true, // Close the shape to connect the last and first points
    //       draggable: true,
    //       tension,
    //       opacity,
    //     })
    //   },
    // },
];
export default shapes;
